import React, { FunctionComponent } from 'react';
import FormField from 'components/form-field/form-field';

export const VatNumberField: FunctionComponent = () => {
  return (
    <FormField
      disabled
      name="vatNumber"
      type="text"
      helpText="Généré automatiquement à partir du numéro de l'entreprise"
      label="Numéro de TVA"
      required
    />
  );
};
